import { useMemo } from "react";
import { Checkbox, Flex, Form, Typography } from "antd";
import FormInput from "./FormInput";
import { useApiCall } from "../../services/api";
import PrimaryButton from "./PrimaryButton";
import SelectTag from "./SelectTag";
import { formRules } from "../../constant";

const { Title } = Typography;

const SalesAddress = ({
  title,
  formData,
  handleSubmit,
  runDefaultHandleSubmit = true,
  closeModal,
}) => {
  const { postApi, loading } = useApiCall();

  // A memoized key that changes when formData's JSON string changes.
  // This forces a re-render of the entire form.
  const formKey = useMemo(() => {
    return JSON.stringify(formData);
  }, [formData]);

  const onFinish = async (values) => {
    if (runDefaultHandleSubmit) {
      const apiRoute =
        formData.type === "residential"
          ? "sales/employee/edit-residential"
          : `sales/employee/edit-office`;

      try {
        const response = await postApi(apiRoute, { ...formData, ...values }, true);
        if (response?.status) {
          closeModal();
          console.log("Address saved successfully");
        }
      } catch (error) {
        console.log("Error", error);
      }
    }
    if (handleSubmit) {
      handleSubmit(values);
    }
  };

  return (
    <>
      <Title className="input-css font-abhaya" level={2}>
        {title || `Edit ${formData.type === "residential" ? "residential" : "office"} address`}
      </Title>
      <Form
        // The most reliable solution: use a key to force a re-mount.
        key={formKey}
        className="mt-6"
        name="address-form"
        layout="vertical"
        autoComplete="off"
        onFinish={onFinish}
        initialValues={{
          ...formData,
          [`${formData.type}_address_line_1`]: formData.address_line_1,
          [`${formData.type}_address_line_2`]: formData.address_line_2,
          [`${formData.type}_city`]: formData.city,
          [`${formData.type}_state`]: formData.state,
          [`${formData.type}_postal_code`]: formData.postal_code,
        }}
      >
        <FormInput
          label="Address Line 1"
          name={`${formData.type}_address_line_1`}
          rules={formRules.required}
        />
        <FormInput
          label="Address Line 2"
          name={`${formData.type}_address_line_2`}
          rules={formRules.required}
        />
        <Flex justify="space-between">
          <FormInput
            label="City"
            name={`${formData.type}_city`}
            rules={formRules.required}
            style={{ width: "48%" }}
          />
          <Form.Item
            rules={formRules.required}
            label="State"
            name={`${formData.type}_state`}
            style={{ width: "48%" }}
          >
            <SelectTag />
          </Form.Item>
        </Flex>
        <FormInput
          label="Postal Code"
          name={`${formData.type}_postal_code`}
          rules={formRules.postalCode}
          maxLength={6}
        />
        <div className="w-full mt-4 flex justify-center pt-3">
          <PrimaryButton
            type="submit"
            text="Save and Proceed"
            className="me-[35px]"
            loading={loading}
          />
        </div>
      </Form>
    </>
  );
};

export default SalesAddress;
